// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__17JEU","calendarButtons":"ClockData_calendarButtons__1YN5t"};